import React, { useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import styles from "./InfoAccordion.module.css";

type Props = { title: string; description: React.ReactNode; defaultOpen?: boolean; buttonText?: string };

export default function InfoAccordion({ title, description, defaultOpen = false, buttonText = "Kenen tili ?" }: Props) {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <div className={styles["info-accordion"]}>
            <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} className={styles["info-accordion__toggle"]}>
                <span className={styles["info-accordion__badge"]}>?</span>
                <span>{buttonText}</span>
                <span className={styles["info-accordion__caret"]}>{open ? <IoIosArrowUp /> : <IoIosArrowDown />}</span>
            </button>

            {open && (
                <div className={styles["info-accordion__panel"]}>
                    <div className={styles["info-accordion__title"]}>{title}</div>
                    <div className={styles["info-accordion__desc"]}>{description}</div>
                </div>
            )}
        </div>
    );
}
